export default{
  //项目概况
  tab_basic_info:{

  },
  //投资流程
  tab_flow:{

  }
}